<template>
  <div class="hokatoto-all">
    <a href="/deluxe/lp/1" @click.prevent="$emit('link', 'dlaxueMenu')" class="banner">
      <img src="/static/img/toppage/lp/hokatotoAll.png" alt="本格＆豪華占い">
    </a>
    <link-button
      v-if="!isSubscrEnable"
      link="/deluxe/10001/input"
      buttonFace="一部無料で占う"
      design="ghost"
      class="btn1"
      @click="$emit('link', 'dlaxueFree')"
    />
  </div>
</template>

<script>
import LinkButton from '@/utvStore/components/partials/LinkButton'

export default {
  name: 'HokatotoAll',
  components: {
    LinkButton
  },
  props: {
    isSubscrEnable: {
      type: Boolean,
      require: true,
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.hokatoto-all {
  margin: 6.4% 5.333%;
  .banner {
    display: block;
    margin: 0 0 4.776%;
    > img {
      max-width: 100%;
      vertical-align: middle;
    }
  }
  .btn1 {
    width: 94%;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/HokatotoAll.vue